import React, { ReactNode } from 'react';

const VideoContainer = ({ children }: { children: ReactNode }) => (
  <div style={{ paddingBottom: '56.25%' }} className="video-container block h-0 w-full relative">
    {children}
  </div>
);

export default VideoContainer;
